import { EMPTY_STRING, MODAL_ID_DEFAULT } from '../../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../../Modal'
import {
  TASK_ACTION_ATTACH_EMAILS,
  TASK_ACTION_ATTACH_FILE,
  TASK_ACTION_SEND_TO_DWELLER,
  TASK_ACTION_SEND_TO_PROVIDER,
  TaskTableCellName,
} from '../../Task'

export const ACTIVITIES_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES =
  'requestProfileTabActivities'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_ACTIVITY = 'addActivity'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_ACTIVITY =
  'addNewActivity'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_START_PHASE = 'startPhase'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_PHASE =
  'addNewPhase'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_INSERT_PHASE = 'insertPhase'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASES_LIMIT =
  'requestProfileTabActivitiesPhasesLimit'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE =
  'requestProfileTabActivitiesPhase'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_EMAILS =
  'requestProfileTabActivitiesPhaseEmails'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_FILES =
  'requestProfileTabActivitiesPhaseFiles'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_VISIBILITY =
  'requestProfileTabActivitiesPhaseVisibility'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_ACTIONS =
  'requestProfileTabActivitiesPhaseActions'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_DRAG_HANDLE =
  'requestProfileTabActivitiesDragHandle'

export const QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ROW_ACTIONS =
  'requestProfileTabActivitiesRowActions'

export const ACTIVITIES_TABLE_CELL_NAME_ACTIONS = 'actions'

export const REQUEST_PROFILE_TAB_ACTIVITIES_TABLE_COLUMNS_CONFIG = {
  [ACTIVITIES_TABLE_CELL_NAME_ACTIONS]: {
    index: 6,
    name: ACTIVITIES_TABLE_CELL_NAME_ACTIONS,
    ordering_field: null,
    title: EMPTY_STRING,
    visible: true,
    width: 48,
  },
  [TaskTableCellName.Deadline]: {
    index: 3,
    name: TaskTableCellName.Deadline,
    ordering_field: null,
    title: 'ActivityTable.DeadlineColumnTitleKey',
    visible: true,
    width: 192,
  },
  [TaskTableCellName.Manager]: {
    index: 2,
    name: TaskTableCellName.Manager,
    ordering_field: null,
    title: 'ActivityTable.ManagerColumnTitleKey',
    visible: true,
    width: 74,
  },
  [TaskTableCellName.Priority]: {
    index: 4,
    name: TaskTableCellName.Priority,
    ordering_field: null,
    title: 'ActivityTable.PriorityColumnTitleKey',
    visible: true,
    width: 115,
  },
  [TaskTableCellName.Status]: {
    index: 0,
    name: TaskTableCellName.Status,
    ordering_field: null,
    title: 'ActivityTable.StatusColumnTitleKey',
    visible: true,
    width: 150,
  },
  [TaskTableCellName.Title]: {
    index: 1,
    name: TaskTableCellName.Title,
    ordering_field: null,
    title: 'ActivityTable.TitleColumnTitleKey',
    visible: true,
    width: 400,
  },
  [TaskTableCellName.VisibleToTenant]: {
    index: 5,
    name: TaskTableCellName.VisibleToTenant,
    ordering_field: null,
    title: EMPTY_STRING,
    visible: true,
    width: 40,
  },
}

// TODO: phase drag-and-drop is hidden until the backend supports phase reorder;
// when enabled, restore the 56px left padding of the phase header for its drag handle
export const REQUEST_PROFILE_TAB_ACTIVITIES_PHASE_DND_ENABLED = false

export const PHASE_COMPLETED_PROGRESS = 100

export const REQUEST_PROFILE_TAB_ACTIVITIES_PHASES_MAX_COUNT = 20

export const PHASE_ACTION_ADD_ACTIVITY = 'phase_add_activity'

export const PHASE_ACTION_TOGGLE_VISIBILITY = 'phase_toggle_visibility'

export const ACTIVITY_ACTION_EDIT = 'activity_edit'

export const ACTIVITY_ACTION_ATTACH_FROM_DOCUMENT_STORAGE =
  'activity_attach_from_document_storage'

export const ACTIVITY_ACTION_ATTACH_FROM_REQUEST_FOLDER =
  'activity_attach_from_request_folder'

export const ACTIVITIES_DND_ID_PREFIX = {
  activity: 'activity',
  phase: 'phase',
}

export const ACTIVITIES_DND_TYPE = {
  activity: 'activity',
  phase: 'phase',
}

export const ACTIVITIES_FIXED_WIDTH_COLUMNS = new Set([
  ACTIVITIES_TABLE_CELL_NAME_ACTIONS,
  TaskTableCellName.VisibleToTenant,
])

export const ACTIVITY_NOTIFICATION_TITLE_KEY = {
  done: 'Notification.TaskMarkAsDoneKey',
  doneError: 'Notification.TaskMarkAsDoneErrorKey',
  hidden: 'Notification.TaskMarkAsHiddenKey',
  hiddenError: 'Notification.TaskMarkAsHiddenErrorKey',
  open: 'Notification.TaskMarkAsOpenKey',
  openError: 'Notification.TaskMarkAsOpenErrorKey',
  shared: 'Notification.TaskMarkAsSharedKey',
  sharedError: 'Notification.TaskMarkAsSharedErrorKey',
}

export const ACTIVITY_SEND_EMAIL_ACTIONS = new Set([
  TASK_ACTION_SEND_TO_DWELLER,
  TASK_ACTION_SEND_TO_PROVIDER,
])

export const ACTIVITY_ITEM_ACTIONS = [
  {
    label: 'RequestProfileTabActivities.EditActivityActionKey',
    value: ACTIVITY_ACTION_EDIT,
  },
  {
    label: 'RequestProfileTabActivities.SendEmailToProviderActionKey',
    value: TASK_ACTION_SEND_TO_PROVIDER,
  },
  {
    label: 'RequestProfileTabActivities.SendEmailToApplicantActionKey',
    value: TASK_ACTION_SEND_TO_DWELLER,
  },
  {
    label: 'RequestProfileTabActivities.AttachEmailActionKey',
    value: TASK_ACTION_ATTACH_EMAILS,
  },
  {
    label: 'RequestProfileTabActivities.AttachFromDesktopActionKey',
    value: TASK_ACTION_ATTACH_FILE,
  },
  {
    label: 'RequestProfileTabActivities.AttachFromDocumentStorageActionKey',
    value: ACTIVITY_ACTION_ATTACH_FROM_DOCUMENT_STORAGE,
  },
  {
    label: 'RequestProfileTabActivities.AttachFromRequestFolderActionKey',
    value: ACTIVITY_ACTION_ATTACH_FROM_REQUEST_FOLDER,
  },
]
